<div id="background"></div>
<ng-container *ngIf="initialize">
  <app-header></app-header>
  <div class="container isBackgoround" style="padding: 0px">
    <main>
      <div class="v-application v-application--is-ltr theme--light main">
          <img
          src="/assets/sgzp-app2/images/unblock.svg"
          width="100"
          height="100"
          alt="unblock"
        />
        <h2 class="text-h6 font-weight-bold text-center mb-6">
          ロックを解除しました
        </h2>
        <p class="text-caption text-subtitle-1 text-center mb-6">
          あなたのアカウントのロックが解除されました。<br />
          {{ countdown }}秒後に、発注提案サービスのトップページへ自動的に移動します。
        </p>
        <p class="text-caption text-center mb-6">
          自動的に移動しない場合は、「トップに戻る」ボタンを押してください。
        </p>

        <div class="mb-6">
          <button (click)="redirect()" class="resetButton font-weight-bold">
            トップに戻る
          </button>
        </div>
      </div>
    </main>
  </div>
</ng-container>
